import { formatGradeValue } from './gradebookTypes';
import styles from './ScoreCell.module.css';

interface ScoreCellProps {
  error?: string;
  inputId?: string;
  isEditing?: boolean;
  label: string;
  maxScore: number;
  onChange?: (value: string) => void;
  value: number | null | string;
}

export function ScoreCell({
  error,
  inputId,
  isEditing = false,
  label,
  maxScore,
  onChange,
  value,
}: ScoreCellProps) {
  const describedBy = error && inputId ? `${inputId}-error` : undefined;
  const displayValue =
    value === null || value === undefined
      ? '—'
      : `${formatGradeValue(Number(value))}/${formatGradeValue(maxScore)}`;

  if (!isEditing) {
    return (
      <div className={styles.readOnly}>
        <span className={styles.label}>{label}</span>
        <span className={styles.readOnlyValue}>{displayValue}</span>
      </div>
    );
  }

  return (
    <label className={styles.editor}>
      <span className={styles.label}>{label}</span>
      <div className={styles.inputRow}>
        <input
          aria-describedby={describedBy}
          aria-invalid={error ? 'true' : 'false'}
          className={styles.input}
          id={inputId}
          inputMode="decimal"
          max={maxScore}
          min={0}
          onChange={(event) => onChange?.(event.target.value)}
          type="number"
          value={value ?? ''}
        />
        <span className={styles.maxValue}>/ {formatGradeValue(maxScore)}</span>
      </div>
      {error && inputId ? (
        <span className={styles.error} id={`${inputId}-error`} role="alert">
          {error}
        </span>
      ) : null}
    </label>
  );
}
